import React, { useMemo } from 'react';
import { Separator as FluentSeparator } from '@fluentui/react';


export function Separator({ error, color = '#a4262c', ...restProps }) {
  const styles = useMemo(() => {
    return error ? { content: { color }, root: { '::before' : { backgroundColor: color } }} : {};
  }, [error, color]);
  
  return (
    <FluentSeparator styles={styles} {...restProps}>
      {error}
    </FluentSeparator>
  );
}


export default Separator;